import { L as LOCALE } from './Locale-e37edea6.js';

const domainLocales = {
    'vi-VN': 'hellobacsi.com',
    'id-ID': 'hellosehat.com',
    'ms-MY': 'hellodoktor.com',
    'km-KH': 'hellokrupet.com',
    'en-PH': 'hellodoctor.com.ph',
    'th-TH': 'hellokhunmor.com',
    'my-MM': 'hellosayarwon.com',
    'zh-TW': 'helloyishi.com.tw',
    'zh-CN': 'hellojiankang.com',
    'hi-IN': 'helloswasthya.com',
    'tl-PH': 'hellodoctor.com.ph',
    'vi-VN_MB': 'marrybaby.vn',
};
const MAP_DOMAIN_BY_LOCALE = {
    [LOCALE.Vietnam]: 'hellobacsi.com',
    [LOCALE.Indonesia]: 'hellosehat.com',
    [LOCALE.Malaysia]: 'hellodoktor.com',
    [LOCALE.Cambodia]: 'hellokrupet.com',
    [LOCALE.PhilippinesEnglish]: 'hellodoctor.com.ph',
    [LOCALE.PhilippinesTagalog]: 'hellodoctor.com.ph',
    [LOCALE.Thailand]: 'hellokhunmor.com',
    [LOCALE.Myanmar]: 'hellosayarwon.com',
    [LOCALE.Taiwan]: 'helloyishi.com.tw',
    [LOCALE.India]: 'helloswasthya.com',
    [LOCALE.China]: 'hellojiankang.com',
};

export { MAP_DOMAIN_BY_LOCALE, domainLocales };
